module.exports = __webpack_public_path__ + "static/media/photo-bank-account.dfa347f4.svg";